import { PSpaceSize } from '../../components'
import variables from '../../assets/scss/shared/ds.variables.module.scss'
import { PScreenSize, screen } from './device'

type ScreenSpaceMap = Partial<Record<PSpaceSize, number>>

type TUseSpaceComposable = {
  getSpacePx: (size: PSpaceSize, target?: PScreenSize) => number
}

const SPACE_PX: Record<PScreenSize, ScreenSpaceMap> = {
  [PScreenSize.MOBILE]: {
    [PSpaceSize.ZERO]: parseInt(variables.spaceZeroMobile),
    [PSpaceSize.XS]: parseInt(variables.spaceXsMobile),
    [PSpaceSize.SM]: parseInt(variables.spaceSmMobile),
    [PSpaceSize.MD]: parseInt(variables.spaceMdMobile),
    [PSpaceSize.LG]: parseInt(variables.spaceLgMobile),
    [PSpaceSize.XL]: parseInt(variables.spaceXlMobile),
    [PSpaceSize.XXL]: parseInt(variables.spaceXxlMobile),
  },
  [PScreenSize.LAPTOP]: {
    [PSpaceSize.ZERO]: parseInt(variables.spaceZeroLaptop),
    [PSpaceSize.XS]: parseInt(variables.spaceXsLaptop),
    [PSpaceSize.SM]: parseInt(variables.spaceSmLaptop),
    [PSpaceSize.MD]: parseInt(variables.spaceMdLaptop),
    [PSpaceSize.LG]: parseInt(variables.spaceLgLaptop),
    [PSpaceSize.XL]: parseInt(variables.spaceXlLaptop),
    [PSpaceSize.XXL]: parseInt(variables.spaceXxlLaptop),
  },
  [PScreenSize.DESKTOP]: {
    [PSpaceSize.ZERO]: parseInt(variables.spaceZeroDesktop),
    [PSpaceSize.XS]: parseInt(variables.spaceXsDesktop),
    [PSpaceSize.SM]: parseInt(variables.spaceSmDesktop),
    [PSpaceSize.MD]: parseInt(variables.spaceMdDesktop),
    [PSpaceSize.LG]: parseInt(variables.spaceLgDesktop),
    [PSpaceSize.XL]: parseInt(variables.spaceXlDesktop),
    [PSpaceSize.XXL]: parseInt(variables.spaceXxlDesktop),
  },
}

export const useSpace = (): TUseSpaceComposable => {
  const getSpacePx = (size: PSpaceSize, target?: PScreenSize): number => {
    const screenSize = target ?? screen().size
    const value = SPACE_PX[screenSize][size]
    if (value === undefined) {
      throw new Error(`Space size "${size}" has no pixel value for screen "${screenSize}"`)
    }
    return value
  }

  return { getSpacePx }
}
